import { Exclude, Type } from "class-transformer";
import { ProductTypeKey } from "@impacgroup/doerr-wildkamera-api-shared";

export class Firmware {
    _id?: string;

    name?: string;
    productType?: ProductTypeKey;
    published: boolean = false;
    publishedBeta: boolean = false;
    imeiWhitelist: string[] = [];

    isForcedVersion: boolean = false;
    enforcementStartDate?: Date;
    enforcementExceptionPeriod?: {
        startTime?: string; // Format "HH:mm"
        endTime?: string; // Format "HH:mm"
    };

    @Exclude({ toPlainOnly: true })
    originalname?: string;
    version?: number;

    @Type(() => Date)
    @Exclude({ toPlainOnly: true })
    created?: Date;

    @Type(() => Date)
    @Exclude({ toPlainOnly: true })
    updated?: Date;
}
